export default "__VITE_ASSET__DAydDSW9__"